Global.api = {
    storeMedia(data) {
        return axios.post('/api/media', data);
    },
};
